import React from "react";
import { Tooltip } from "antd";
import { AlertOutlined } from "@ant-design/icons";
import "./stalledPill.scss";

// F-03 — the single stalled marker used everywhere an item can be flagged as
// stalled (site-visit table, coordinator queue, home panels, previews).
//
// Same tinted-pill geometry as the platform's status pills (3px 10px, 16px
// radius, Poppins 12/500) in the escalation purple already used by the task
// queue's stalled pill and the "Stalled items" KPI. Self-contained styles so it
// also renders correctly inside modals, which portal outside .projectHome.
const StalledPill = ({ stalledSince, days }) => {
  const suffix =
    days != null && !isNaN(days) && days >= 0 ? ` · ${days}d` : "";
  return (
    <Tooltip
      title={
        stalledSince
          ? `No update since ${stalledSince}`
          : "No update for longer than the escalation threshold"
      }
    >
      <span className="stalledPill">
        <AlertOutlined />
        Stalled{suffix}
      </span>
    </Tooltip>
  );
};

export default StalledPill;
